import { render, staticRenderFns } from "./AcademicYearListPage.vue?vue&type=template&id=4ef22e22&scoped=true"
import script from "./AcademicYearListPage.vue?vue&type=script&lang=js"
export * from "./AcademicYearListPage.vue?vue&type=script&lang=js"
import style0 from "./AcademicYearListPage.vue?vue&type=style&index=0&id=4ef22e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef22e22",
  null
  
)

export default component.exports